import React from 'react';

import { di } from 'react-magnetic-di';

import { FireUIAnalytics } from '@atlassian/analytics-bridge/fire-analytics';
import { Action, ActionSubject } from '@atlassian/proforma-utilities/analytics/events';

import { asFilesValue } from '../../../../../../../../common/types/form/form-fields/field-values/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { AttachmentErrorState } from '../../../../../../../../common/ui/attachment-error-state';
import { AttachmentSharedFilmstrip } from '../../../../../../../../common/ui/shared-filmstrip';
import {
	useAttachmentConfiguration,
	useCurrentValue,
} from '../../../../../../../../controllers/form-renderer-store';
import { EmptyState } from './empty-state';

export const ViewAttachmentField = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useAttachmentConfiguration, useCurrentValue);

	const currentValue = useCurrentValue({ fieldId });
	const filesValue = asFilesValue(currentValue) ?? { files: [] };

	const attachmentConfiguration = useAttachmentConfiguration();

	const mediaClientConfig = attachmentConfiguration?.read?.mediaClientConfig;

	if (!mediaClientConfig) {
		return <AttachmentErrorState />;
	}

	return (
		<>
			{filesValue.files.length > 0 ? (
				<AttachmentSharedFilmstrip files={filesValue.files} mediaClientConfig={mediaClientConfig} />
			) : (
				<EmptyState />
			)}
			<FireUIAnalytics
				actionSubject={ActionSubject.ATTACHMENT_VIEWER}
				action={Action.VIEWED}
				actionSubjectId="proformaAttachmentViewerField"
			/>
		</>
	);
};
